import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CountryCode } from 'libphonenumber-js';
import { Logger } from '../../../../../../../infrastructure/logging/logger';
import { AccountService } from '../../../../../../../shared/account/account.service';
import { formatPhoneNumber } from '../../../../../../../utilities/PhoneUtility';
import { UserContextProvider } from '../../../../../../../infrastructure/context/user-context-provider';

export interface OrgMembersUpdateDialogData {
  accountId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
}

@Component({
  selector: 'app-org-members-update-dialog',
  templateUrl: './org-members-update-dialog.component.html',
  styleUrls: ['./org-members-update-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class OrgMembersUpdateDialogComponent implements OnInit {

  formControl!: FormGroup;
  matcher = new ErrorStateMatcher();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrgMembersUpdateDialogData,
    private dialogRef: MatDialogRef<OrgMembersUpdateDialogComponent>,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private userContextProvider: UserContextProvider,
    private logService: Logger
  ) { }

  ngOnInit(): void {
    this.formControl = this.formBuilder.group({
      firstName: [this.data.firstName, [Validators.required]],
      //middleName: [this.data.middleName],
      lastName: [this.data.lastName, [Validators.required]],
      emailAddress: [this.data.emailAddress, [Validators.required]],
      phone: [this.data.phoneNumber, Validators.pattern(/^[\s()+-]*([0-9][\s()+-]*){10,11}(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i)]
    });
  }

  onPhoneNumberChanged(event: Event) {
    this.updatePhoneNumber((event.target as HTMLInputElement).value);
  }

  updatePhoneNumber(phoneNumber: string) {
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber, this.userContextProvider.countryCode as CountryCode);
    this.formControl.patchValue({ phone: formattedPhoneNumber });
  }

  async onSaveClick() {
    try {
      this.updateData();
      await this.accountService.updateAccountInfo({ ...this.data });
      this.dialogRef.close(true);
    } catch (e) {
      this.logService.handleError(e, `Error while updating Member Account for Account ID: ${this.data.accountId}`, `Error while updating Member Account for Account ID: ${this.data.accountId}`);
    }
  }

  updateData() {
    this.data.firstName = this.formControl.controls['firstName'].value;
    //this.data.middleName = this.formControl.controls['middleName'].value;
    this.data.lastName = this.formControl.controls['lastName'].value;
    this.data.emailAddress = this.formControl.controls['emailAddress'].value;
    this.data.phoneNumber = this.formControl.controls['phone'].value;
  }

  onCloseClick(): void {
    this.dialogRef.close(false);
  }
}